<script>
  import { onMount } from "svelte";
  import {debounce, ignore} from "./tools";
  import {External, M} from "../external";

  export let term = "",
    onSearch = ignore;

  let input = null;
  let lastTerm = "";

  let doSearch = debounce(() => {
    if (term.trim() !== lastTerm.trim()) {
      lastTerm = term;
      onSearch(term.trim());
    }
  }, 500);

  let clearSearch = () => {
    term = "";
    doSearch();
  };

  onMount(() => {
    window.setTimeout(() => input.focus(), 10);
  });
</script>

<div class="col20 f-left flex flex-row search-box-wrapper justify-center align-center">
  <input bind:this={input} type="text" class="flex-one" bind:value={term} on:keyup={doSearch} placeholder={M.SEARCH}/>

  <a on:click={clearSearch} class="flex align-center justify-center circle-button red rounded-effect flex-none ml-10">
    <span class="material-icons-outlined" style="font-size:20px;">cancel</span>
  </a>
</div>
